<template>
  <div v-if="readOnlyProp === false">
    <input type="hidden" v-model="remove" />
    <button class="close" @click="removeItem">
      <font-awesome-icon :icon="['fas', 'xmark']" />
    </button>
  </div>
  <div class="filter_box">
    <div v-if="readOnlyProp === false" class="date_filter">
      <div class="date_period_first">Handler ID</div>
      <div class="date_period_second" ref="handlerKey">{{ handlerKey }}</div>
    </div>
    <div v-if="readOnlyProp === false" class="date_filter">
      <div class="date_period_first">Filter Type</div>
      <div class="date_period_second">Multi</div>
    </div>
    <div class="date_filter">
      <div class="date_period_first">제어 Handler</div>
      <div class="date_period_second">
        <select v-model="parentHandlerKey" @change="updateParent($event)">
          <option value="" selected>None</option>
          <option
            v-for="item in handlerList.filter(
              (ele) => ele.handlerKey !== otherProp.handlerKey
            )"
            :key="item.handlerKey"
            :value="item.handlerKey"
          >
            handlerKey : {{ item.handlerKey }}
          </option>
        </select>
      </div>
    </div>
    <div v-if="readOnlyProp === false" class="date_filter">
      <div class="date_period_first">Type</div>
      <div class="date_period_second">
        <select
          v-model="barKeyValueType"
          @change="keyValueTypeChange"
          style="width: 145px"
        >
          <option value="">Select Type</option>
          <option value="checkbox">checkbox</option>
          <option value="radio">radio</option>
        </select>
      </div>
    </div>
    <div v-if="readOnlyProp === false" class="date_filter">
      <div class="date_period_first">Value</div>
      <div class="date_period_second" style="gap: 10px">
        <button @click="insertKeyValue">
          <font-awesome-icon :icon="['fas', 'plus']" />
        </button>
        <input type="text" v-model="inputKey" />
        <input type="text" v-model="inputValue" />
      </div>
    </div>
    <div
      class="date_filter"
      style="min-height: 50px; height: auto; background-color: #00b4ed"
    >
      <div
        class="date_period_first"
        style="min-height: 50px; border-bottom: 0"
      ></div>
      <div
        class="date_period_second"
        style="min-height: 50px; background-color: #fff"
      >
        <ul>
          <li v-for="(item, index) in keyValueList" :key="index">
            <div>
              <button @click="removeKeyValue(index)">
                <font-awesome-icon :icon="['fas', 'xmark']" />
              </button>
            </div>
            <div><input type="text" disabled :value="item.key" /></div>
            <div>
              <input type="text" disabled :value="item.value" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    otherProp: {
      type: Object,
      required: true,
    },
    readOnlyProp: {
      type: Boolean,
      require: true,
    },
    handlerList: {
      type: Object,
      require: true,
    },
    componentIndex: {
      type: Number,
    },
    keyValueList: {
      type: Object,
    },
    keyValueType: {
      type: String,
    },
  },
  data() {
    return {
      labelText: "",
      handlerKey: "",
      color: ["#36a2eb", "#ff6384", "#ff9f40", "#ffcd56", "#4bc0c0"],
      picStartDate: null,
      picEndDate: null,
      start_cal_key: 0,
      end_cal_key: 0,
      picStartDateCalendar: null,
      picEndDateCalendar: null,
      picColor: {
        startStatus: false,
        endStatus: false,
        active: "#00B4ED",
        default: "#020A0A",
      },
      onlyRead: false,
      remove: false,
      DataMapCateGory: "Data",
      parentHandlerKey: "",
      barKeyValueType: "",
      inputKey: "",
      inputValue: "",
      barKeyValueList: [],
    };
  },
  mounted() {
    const vm = this;
    const prop = this.otherProp;
    const handlerList = this.handlerList;
    vm.onlyRead = prop.readOnlyProp; //읽기전용 체크
    vm.handlerKey = prop.handlerKey; //handlerKey
    if (vm.parentHandlerKey !== undefined) {
      vm.parentHandlerKey = prop.parentHandlerKey; // 부모키
    }
    vm.labelText = prop.labelText;
    vm.parameter = prop.parameter;
    vm.barKeyValueList = prop.keyValueList;
    vm.barKeyValueType = prop.keyValueType;
    //handler 제어 할려면 handler ID 값을 따로 저장해두는 곳이 있어야 하지 않나...
    console.log("select bar");
    console.log(handlerList);
  },
  methods: {
    updateParent(event) {
      this.$emit("updateParent", {
        index: this.componentIndex,
        value: event.target.value,
      });
      console.log(this.handlerList);
    },
    labelTextChange(event) {
      this.labelText = event.target.value;
      const item = this.otherProp;
      item.labelText = this.labelText;
    },
    parameterTextChange(event) {
      this.parameter = event.target.value;
      const item = this.otherProp;
      item.parameter = this.parameter;
    },
    removeItem() {
      this.$emit("removeItem");
    },
    insertKeyValue() {
      const vm = this;
      const key = vm.inputKey;
      const value = vm.inputValue;
      const object = { key: key, value: value };
      this.barKeyValueList.push(object);
      const item = this.otherProp;
      item.keyValueList = this.barKeyValueList;
    },
    removeKeyValue(index) {
      this.barKeyValueList.splice(index, 1);
      const item = this.otherProp;
      item.keyValueList = this.barKeyValueList;
    },
    keyValueTypeChange(event) {
      const keyValue = event.target.value;
      this.barKeyValueType = keyValue;
      this.$emit("update:keyValueType", this.barKeyValueType);
      const item = this.otherProp;
      item.keyValueType = this.barKeyValueType;
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.list_filter_wrap {
  height: 80px;
  overflow: visible;
  .filter_list_box {
    &::after {
      border-radius: 10px;
    }
  }
}
.chart_wrap {
  width: 100%;
  display: flex;
  gap: 50px;
  margin-top: 50px;
  .chart {
    width: 100%;
  }
}
.code_search_table {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  & > div {
    flex: 1;
  }

  select {
    width: 100%;
    height: 45px;
    background-position: 96%;
  }
}
.filter_box {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  box-sizing: border-box;
  .search_from_box {
    position: absolute;
    right: -120px;
    .btn_send {
      height: 40px;
      padding: 0 15px;
      border-radius: 10px;
      line-height: 37px;
      font-size: 15px;
    }
  }
  .date_filter {
    position: relative;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center; /* 세로 중앙 정렬 */
    text-align: center; /* 텍스트 가로 정렬 */
    padding-left: 0;
    &::after {
      display: none;
    }
    &:first-child {
      .date_period_second {
        border-top: 1px solid #d5dae3;
      }
    }
    .date_period {
      width: 240px;
      display: flex;
      justify-content: flex-end; /* 가로 중앙 정렬 */
      align-items: center; /* 세로 중앙 정렬 */
      text-align: center; /* 텍스트 가로 정렬 */
    }
    .date_period_first {
      width: 335px;
      display: flex;
      height: 100%;
      border-bottom: 1px solid #fff;
      box-sizing: border-box;
      background-color: #00b4ed;
      color: #fff;
      font-weight: 600;
      justify-content: center; /* 가로 중앙 정렬 */
      align-items: center; /* 세로 중앙 정렬 */
      text-align: center; /* 텍스트 가로 정렬 */
    }
    .date_period_second {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-right: 1px solid #d5dae3;
      border-bottom: 1px solid #d5dae3;
      box-sizing: border-box;
      select {
        background-position: center right 15px;
      }
      input {
        height: 40px !important;
        border: 1px solid #d5dae3 !important;
        border-radius: 10px !important;
      }
      ul {
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        li {
          display: flex;
          gap: 10px;
        }
      }
    }
  }
}
.close {
  font-size: 20px;
  color: #bbb;
}
</style>
